interface LastRequestTime {
    userID: string
    time: number
}

function getLastRequestTime(): LastRequestTime | null {
    const lastRequest = localStorage.getItem('lastRequestTime')
        ? JSON.parse(localStorage.getItem('lastRequestTime')!)
        : null
    return lastRequest
        ? {
              userID: lastRequest.userID,
              time: parseInt(lastRequest.time, 10)
          }
        : null
}

export function setLastRequestTime(userID: string) {
    const cache = {
        userID,
        time: Date.now().toString()
    }

    localStorage.setItem('lastRequestTime', JSON.stringify(cache))
}

export function canMakeRequest(idUser: string) {
    const lastRequestTime = getLastRequestTime()
    if (!lastRequestTime) return true
    if (lastRequestTime.userID !== idUser) return true

    const now = Date.now()
    const elapsed = now - lastRequestTime.time
    return elapsed >= 24 * 60 * 60 * 1000 // 24 horas em milissegundos
}
